import { createContext, useContext } from 'react';
import type { FormatParams, LocaleDef, LocaleId, TranslationKey } from './index';

/*
 * ההקשר וה-hook יושבים בקובץ נפרד מהרכיב בכוונה: קובץ שמייצא רכיב וגם משהו שאינו
 * רכיב מבטל את Fast Refresh לכל המודול, וכל עריכה קטנה ב-i18n הייתה גוררת טעינה
 * מלאה של הדף באמצע עבודה.
 */

export interface I18nValue {
    readonly locale: LocaleId;
    readonly localeDef: LocaleDef;
    readonly t: (key: TranslationKey, params?: FormatParams) => string;
    readonly setLocale: (next: LocaleId) => void;
    /** מעבר מחזורי לשפה הבאה — עדיף על בורר כל עוד יש שתיים או שלוש. */
    readonly cycleLocale: () => void;
}

export const I18nContext = createContext<I18nValue | null>(null);

export function useI18n(): I18nValue {
    const value = useContext(I18nContext);
    if (!value) throw new Error('useI18n חייב לרוץ בתוך I18nProvider');
    return value;
}
